import React from 'react'
import map from 'lodash/map'
import classnames from 'classnames'

import {
  IAccount,
  ISetCurrentAccountPayload,
} from '@SiteModules/Account/types'

interface AccountsListProps {
  readonly accounts: IAccount[]
  readonly currentAccountId: number
  setCurrentAccount(payload: ISetCurrentAccountPayload): void
}

const AccountsList: React.FC<AccountsListProps> = props => {
  const {
    currentAccountId,
    accounts,
  } = props

  const accountsList = map(accounts, account => {
    const isCurrentAccount = account.id === currentAccountId
    const lastDigitOfAccountId = account.id % 10

    const changeAccount = () => {
      if (isCurrentAccount) { return }

      props.setCurrentAccount({ accountId: account.id })
    }

    return (
      <li
        key={account.id}
        className={classnames(
          'AccountPopup__account',
          { 'AccountPopup__account-active': isCurrentAccount }
        )}
        onClick={changeAccount}
      >
        {account.attributes.avatarUrl ? (
          <img
            src={account.attributes.avatarUrl}
            alt={account.attributes.name}
            className="AccountPopup__avatar"
          />
        ) : (
          <div
            className={classnames(
              'AccountPopup__avatar-placeholder',
              `AccountPopup__avatar-placeholder-background-${lastDigitOfAccountId}`
            )}
          >
            {account.attributes.name.charAt(0)}
          </div>
        )}
        <div className="AccountPopup__account-name">
          {account.attributes.name}
        </div>
      </li>
    )
  })

  return (
    <div className="AccountPopup__accounts">
      <ul className="AccountPopup__accounts-list">
        {accountsList}
      </ul>
    </div>
  )
}

export default AccountsList
